module.exports = __webpack_public_path__ + "img/hk_idCard-1.f50271e5.png";